export default {
	diagnostics: {
		// Siehe en/diagnostics.ts: Schlüssel ist der stabile `code` des Generators.
		manualCodeName:
			"Dieser Code-Name wurde manuell gesetzt. Er folgt Umbenennungen des Begriffs nicht mehr.",
	},
};
